import { AnalysisSelectionNew } from 'enums';
import React from 'react';
import { Assessment } from 'types/analysis-result.types';
import { ProfileValues } from 'types/profile.types';
import BoosterWords from './booster-words';
import DoComponent from './do-component';
import StyleMatch from './style-match';
import { makeStyles } from 'tss-react/mui';

interface Props {
  contactName: string | undefined;
  selectedAnalysis: AnalysisSelectionNew;
  contactAssessment: Assessment | undefined;
  contactProfile: ProfileValues | undefined;
  userProfile: ProfileValues | undefined;
}

const AnalysisTabContent: React.FC<Props> = ({ contactName, selectedAnalysis, contactAssessment, contactProfile, userProfile }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.tabContent}>
      {selectedAnalysis === AnalysisSelectionNew.PERSONALITY_TYPE ? (
        <StyleMatch contactName={contactName} contactAssessment={contactAssessment} contactProfile={contactProfile} userProfile={userProfile} />
      ) : selectedAnalysis === AnalysisSelectionNew.DOS_AND_DONTS ? (
        <DoComponent assessment={contactAssessment} />
      ) : selectedAnalysis === AnalysisSelectionNew.BOOSTER_WORDS ? (
        <BoosterWords assessment={contactAssessment} />
      ) : null}
    </div>
  );
};

const useStyles = makeStyles()(() => ({
  tabContent: {
    overflow: 'auto',
  },
}));

export default AnalysisTabContent;
